'use strict';

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _applicationState = require('../utils/applicationState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adInterface = {
  init: function init() {
    global.addEventListener('message', this.handleMessage.bind(this), false);
  },
  isValidUnlockParameter: function isValidUnlockParameter(data) {
    return data && data.campaignId && data.campaignKey && data.unlockToken;
  },
  handleUnlockMessage: function handleUnlockMessage(data) {
    var premiumUnlockCallback = (0, _applicationState.getState)(_applicationState.State.onPremiumUnlockEvent);
    if (premiumUnlockCallback && (0, _isFunction2.default)(premiumUnlockCallback) && this.isValidUnlockParameter(data)) {
      premiumUnlockCallback(data);
    }
  },
  handleMessage: function handleMessage(event) {
    if (!event.data || !(0, _isString2.default)(event.data) || !(0, _startsWith2.default)(event.data, 'ti:')) {
      return;
    }

    var json = event.data.substring(3);
    var data = void 0;
    try {
      data = JSON.parse(json);
    } catch (e) {
      // eslint-disable-line
      return;
    }

    if (data.type === 'premiumUnlock') {
      this.handleUnlockMessage(data);
    }
  }
};

module.exports = adInterface;